var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint @typescript-eslint/no-explicit-any: 0 */ // --> OFF
import { useCallback, useEffect, useState } from 'react';
import { useLabProgress } from './useLabProgress';
export const useLabCommands = (virtualMachines, vLabId, isElectron) => {
    const { importProgress, downloadProgress, setDownloadProgress, setImportProgress, onVMImageDownloadProgress, onVMImportProgress } = useLabProgress(virtualMachines);
    const [cachedImageSize, setCachedImageSize] = useState(0);
    const [labReadyToLaunch, setLabReadyToLaunch] = useState(false);
    const [labLaunching, setLabLaunching] = useState(false);
    const [isInstalling, setIsInstalling] = useState(false);
    const [virtualBoxInstalled, setVirtualBoxInstalled] = useState(false);
    const onImageDownloadProgress = (event) => {
        if (!isInstalling)
            setIsInstalling(true);
        onVMImageDownloadProgress(event);
    };
    const onImportProgress = (event) => {
        if (!isInstalling)
            setIsInstalling(true);
        onVMImportProgress(event);
    };
    const labCheck = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!isElectron)
            return;
        let isInstalled = true;
        try {
            isInstalled = yield window.labApi.isVirtualBoxInstalled();
        }
        catch (error) {
            console.error(error);
        }
        console.log(`Is Installed: ${isInstalled}`);
        setVirtualBoxInstalled(isInstalled);
        if (!isInstalled)
            return;
        let cachedImageSize = 0;
        try {
            cachedImageSize = yield window.labApi.getCachedImageFolderSize();
        }
        catch (error) {
            console.error(error);
        }
        console.log(`Cached image size: ${cachedImageSize}`);
        setCachedImageSize(cachedImageSize);
        const readyToLaunch = yield window.labApi.isLabReadyToLaunch({
            uuid: vLabId,
            name,
            vms: virtualMachines
        });
        setLabReadyToLaunch(readyToLaunch);
    }), [setLabReadyToLaunch, setCachedImageSize, setVirtualBoxInstalled, vLabId, virtualMachines, isElectron]);
    useEffect(() => {
        if (isElectron) {
            window.labApi.registerDownloadProgressCallback(onImageDownloadProgress);
            window.labApi.registerImportProgressCallback(onImportProgress);
            labCheck();
        }
        return () => {
            if (isElectron) {
                window.labApi.unregisterDownloadProgressCallback(onImageDownloadProgress);
                window.labApi.unregisterImportProgressCallback(onImportProgress);
            }
        };
    }, [isElectron, vLabId]);
    const deleteLab = useCallback((vms, name, vLabId) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isElectron)
            return;
        console.log('Deleting lab');
        yield window.labApi.deleteLab({ uuid: vLabId, name, vms });
        console.log('Lab deleted');
        setImportProgress(0);
        labCheck();
    }), [labCheck, isElectron]);
    const downloadAndImport = useCallback((vms, name, vLabId) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isElectron)
            return;
        setIsInstalling(true);
        console.log('Importing lab');
        yield window.labApi.downloadAndImportLab({ uuid: vLabId, name, vms }).catch((e) => {
            console.log(e);
            setIsInstalling(false);
            deleteLab(vms, name, vLabId);
            return;
        });
        console.log('Import complete');
        labCheck();
        setIsInstalling(false);
    }), [labCheck, isElectron, deleteLab]);
    const deleteCachedImages = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!isElectron)
            return;
        console.log('Deleting cached images');
        yield window.labApi.deleteCachedImages();
        console.log('Cached images deleted');
        setDownloadProgress(0);
        labCheck();
    }), [labCheck, isElectron]);
    const launchVM = useCallback((labId, machineName) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isElectron)
            return;
        console.log(`Launching machine: ${machineName} in lab ${labId}`);
        const { error } = yield window.labApi.launchVirtualMachines(labId, [machineName]);
        if (error) {
            console.error(error);
        }
        else {
            console.log('Launched machine: ' + machineName);
        }
    }), [isElectron]);
    const launchLab = useCallback((labId) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isElectron || labLaunching)
            return;
        setLabLaunching(true);
        yield Promise.all(virtualMachines.map(({ name }) => {
            launchVM(labId, name);
        })).catch(() => {
            setLabLaunching(false);
        });
        setLabLaunching(false);
        return;
    }), [isElectron, setLabLaunching, launchVM, labLaunching, virtualMachines]);
    return {
        downloadAndImport,
        deleteLab,
        deleteCachedImages,
        launchVM,
        labCheck,
        launchLab,
        downloadProgress,
        importProgress,
        cachedImageSize,
        virtualBoxInstalled,
        isInstalling,
        labReadyToLaunch
    };
};
//# sourceMappingURL=useLabCommands.js.map